import { inject, computed } from "vue";
import {
  useFieldError,
  useIsFieldDirty,
  useIsFieldTouched,
  useIsFieldValid,
} from "vee-validate";
import { FORM_ITEM_INJECTION_KEY } from "./injectionKeys";

export function useFormField() {
  const fieldContext = inject(FORM_ITEM_INJECTION_KEY);

  if (!fieldContext) {
    throw new Error("useFormField should be used within <FormField>");
  }

  const { name, id } = fieldContext;

  // Без обёртки <FormField> поле в vee-validate не зарегистрировано (name пуст),
  // и его composable-хелперы пытаются заинжектить инстанс поля, которого нет.
  // В этом режиме примитивы используются только для разметки — отдаём инертное состояние.
  const fieldState = name
    ? {
        valid: useIsFieldValid(name),
        isDirty: useIsFieldDirty(name),
        isTouched: useIsFieldTouched(name),
        error: useFieldError(name),
      }
    : {
        valid: computed(() => true),
        isDirty: computed(() => false),
        isTouched: computed(() => false),
        error: computed(() => undefined),
      };

  const formItemId = computed(() => `${id}-form-item`);
  const formDescriptionId = computed(() => `${id}-form-item-description`);
  const formMessageId = computed(() => `${id}-form-item-message`);

  return {
    id,
    name,
    formItemId,
    formDescriptionId,
    formMessageId,
    ...fieldState,
  };
}
